<template>
	<div id="wrapper">
		<RTHeader/>
    <RTNavigation/>
		<div id="main">
			<div class="inner">
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner"></div>
            <p>Daten werden geladen...</p>
        </div>
        <div v-else-if="error">{{ error }}</div>
				<header v-else>
					<p><router-link to="/" class="body-2 font-weight-bold"> <span class="mr-05 icon solid fa-chevron-left primary-color"></span>zurück zur Übersicht</router-link></p>
          <h2 v-if="!_.isEmpty(shop)">{{shop.title}}</h2>
          <div v-if="!_.isEmpty(shop)" class="row gtr-uniform">
            <div v-show="!isEmpty(shop,'img')" class="col-6 col-12-xsmall">
              <a v-if="!isEmpty(shop,'url')" class="no-deco" target="_blank" :href="shop.url"><img :src="shop.img" class="cover"></a>
              <img v-else :src="shop.img" class="cover" style="width:100%">
            </div>
            <div class="col-6 col-12-xsmall mt-1">
              <p v-html="shop.descr"></p>
              <p v-if="!isEmpty(shop,'company')"><i class="icon solid fa-building"></i> {{shop.company}}</p>
              <p v-if="!isEmpty(shop,'url')"> <i class="icon solid fa-globe"></i> <a :href="shop.url" target="_blank">{{shop.url}}</a></p>
              <p v-if="hasShippingText(shop)"> <i class="icon solid fa-truck"></i> {{shop.shipText}}</p>
              <p v-if="hasCategory(shop)"> <i class="icon solid fa-tags"></i> {{getCategoriesAsString(shop.category)}}</p>
            </div>
            <hr class="w-100 m-0">
            <div v-if="hasContact(shop)" :class="hasPosition(shop)?'col-6':'col-12'" class="col-12-xsmall">
              <h2> Kontakt</h2>
              <p class="mb-1" v-if="!isEmpty(shop,'name')">
                <i class="icon solid fa-user-circle"></i> {{shop.name}}
              </p>
              <p class="mb-1"  v-if="!isEmpty(shop,'nr') || !isEmpty(shop,'country') ">
                <i v-if="!isEmpty(shop,'nr')" class="icon solid fa-circle"></i> {{shop.nr}}
                <span v-if="!isEmpty(shop,'country')"> ({{getCountryAsString(shop)}})</span>
              </p>
              <p class="mb-1"  v-if="!isEmpty(shop,'email')">
                <i class="icon solid fa-envelope"></i> <a :href="'mailto:'+shop.email">{{shop.email}}</a>
              </p>
              <p class="mb-1"  v-if="!isEmpty(shop,'tel')">
                <i class="icon solid fa-phone-alt"></i> <a :href="'tel:'+shop.tel">{{shop.tel}}</a>
              </p>
            </div>
            <div v-if="hasPosition(shop)" class="col-6 col-12-xsmall">
               <RTMap
              :items="[shop]"
              :singleMarkerMode="false"
              :initialZoom="10"
              :height="'250px'" />
            </div>
            <div class="mt-3 col-12 col-12-xsmall">
              <i class="icon solid fa-exclamation-circle"></i> <a :href="'mailto:kontakt@tobiashubold.de?subject=Beitrag aktualisieren / melden&body='+getDefaultMailTextForEntry(shop)">Eintrag aktualisieren / melden</a>
            </div>
          </div>
          <div v-if="_.isEmpty(shop)" class="primary-color">
            Leider können wir diesen Eintrag nicht finden.
          </div>
				</header>
      </div>
		</div>

    <!-- Footer -->
    <RTFooter></RTFooter>
  </div>
</template>

<script>

import RTMap from '@/components/RTMap.vue'
import RTHeader from '@/components/RTHeader.vue'
import RTNavigation from '@/components/RTNavigation.vue'
import RTFooter from '@/components/RTFooter.vue'
//import jsonShops from '@/assets/shops.json';
import {categoryBase} from '@/mixins/categoryBase.js'
import {helper} from '@/mixins/helper.js'
import {shopBase} from '@/mixins/shopBase.js'

export default {
  name: 'ShopView',
  mixins:[helper,categoryBase,shopBase],
  components: {
    RTHeader,
    RTNavigation,
    RTFooter,
    RTMap
  },
  props:['id'],
  data: function() {
    return {
      shops: [],
      shop: null,
      isLoading: true, // Ladestatus
      error: null
    };
  },
    metaInfo() {
      return {
          title: this.shareTitle,
          link: [
                  {rel: 'canonical', href: this.getShopUrl(this.shop)}
                ],
          meta: [
              { name: 'title', content: this.shareTitle},
              { name: 'description', content: this.shareDescription},
              { property: 'og:title', content: this.shareTitle},
              { property: 'og:site_name', content: this.shareTitle},
              { property: 'og:description', content: this.shareDescription},
              { property: 'og:type', content: 'profile'},
              { property: 'og:url', content: this.getShopUrl(this.shop)},
              { property: 'og:image', content: this.shareImage },
              { property: 'twitter:image:alt', content: this.shareImage},
              { property: 'twitter:card', content: `${this.shareTitle} in ${this.shareDescription}`}
          ]
      }
  },
  computed:{
        /** Sharing */
    shareTitle(){
      return `${(this.shop && this.shop.title)?this.shop.title:'vontablern.de'}`;
    },
    shareDescription(){
      let maxLength=120;
      let descr=(this.shop && this.shop.descr)?this.shop.descr:'';
      let address= ''
      let maxTitleLength=maxLength-address.length-3; // 3 dots
      let shortenAddress= (descr.length+address.length> maxLength)?`...${descr.substr(0, maxTitleLength)}`:descr;
      return `${shortenAddress} ${address}`;
    },
    shareImage(){
      return (this.shop)?this.getModifiedImage(this.shop.img):'https://vontablern.de/images/preview.jpg';
    },
  },
  methods:{
    getShopUrl(shop){
      return (shop)?(`/shop/${this.removeSpecialCharsFromString(shop.title)}`):'';
    },
    getDefaultMailTextForEntry(shop){
      let id=(shop)?shop.id:"?";
      return "Hallo, ich habe folgendes Anliegen zum Beitrag https://vontablern.de/shop/"+id+": ";
    },
    enhanceData(shop){
      if(shop){
        shop.shipText=this.getShippingAsString(shop);
        shop.img=this.getModifiedImage(shop.img);
      }
      return shop;
    }
  },
  beforeRouteEnter: (to,from,next) => {
		next(() => {
       setTimeout(()=>{
				window.scrollTo(0, 0);
			},300);
		});
	},
  async mounted() {
    try {
      const response = await fetch('/api.php');
      if (!response.ok) throw new Error('Fehler beim Laden');
      this.shops = await response.json();
      
      // Shop finden wie bisher
      this.shop = this.getShopById(this.shops, this.id);
      this.shop = this.enhanceData(this.shop);
    } catch (e) {
      this.error = e.message;
    } finally {
      this.isLoading = false;
    }
  },
  destroyed() {
    this.shop=null;
  },
};
</script>

<style scoped type='text/css'>
.cover{
  max-width: 100%;
  max-height: 400px;
}
</style>